/**
 * Updates article grid with more tiles
 * @param {jQuery} $loadMore The load more button
 * @param {jQuery} $loadMoreContainer The load more button container
 * @param {string} selectedValueUrl The URL for the call
 */
function loadMore($loadMore, $loadMoreContainer, selectedValueUrl) {
    var $container = $(".bloglanding").length > 0 ? $(".bloglanding .experience-articleGrid .row") : $(".blogFolder__row");

    $.ajax({
        url: selectedValueUrl,
        method: "GET",
        dataType: "json",
        success: function (data) {
            for (var i = 0; i < data.articles.length; i++) {
                $container.append(data.articles[i]);
            }
            if (data.start === 0) {
                $loadMore.hide();
                $loadMoreContainer.hide();
            } else {
                $loadMore.show();
                $loadMoreContainer.show();
                $(".blog-post-count__visible").text(data.count);
                $loadMore.attr("data-url", data.loadMoreURL);
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates article grid with room filter
 * @param {string} url The URL for the selected room filter
 */
function filterByRoom(url) {
    if (!url) {
        return;
    }

    $.spinner().start();

    var isBlogLanding = $(".bloglanding").length > 0;
    var $container = isBlogLanding ? $(".bloglanding .experience-articleGrid") : $(".blogFolder__row");
    var $loadMore = isBlogLanding ? $(".blog-load-more") : $(".blogFolder__load-and-count");

    $.ajax({
        url: url,
        method: "GET",
        dataType: "json",
        success: function (data) {
            $container.empty();

            if (data.loadMore && data.loadMoreURL !== "") {
                $loadMore.show();
                if (isBlogLanding) {
                    $(".blog-post-count").show();
                }
                $(".blog-load-more").attr("data-url", data.loadMoreURL);
                $(".blog-post-count__visible").text(data.articleCount.visible);
                $(".blog-post-count__total").text(data.articleCount.total);
            } else {
                $loadMore.hide();
                if (isBlogLanding) {
                    $(".blog-post-count").hide();
                }
            }

            var $row;

            if ($container.find(".row").length === 0) {
                $row = $("<div/>").addClass("row");
            }

            for (var i = 0; i < data.articles.length; i++) {
                if ($container.find(".row").length === 0) {
                    $row.append(data.articles[i]);
                } else {
                    $container.append(data.articles[i]);
                }
            }

            if ($row) {
                $container.append($row);
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    selectTopic: function () {
        $(document).on("change", ".blog-filters .blog-topic-select", function (e) {
            e.preventDefault();
            window.location.assign(e.currentTarget.value);
        });
    },
    loadMore: function () {
        $(".blog-load-more.blog-load-more--landing").on("click", function () {
            var $loadMore = $(this);
            var $loadMoreContainer = $(".blog-post-count");
            var selectedValueUrl = $loadMore.attr("data-url");
            if (selectedValueUrl) {
                loadMore($loadMore, $loadMoreContainer, selectedValueUrl);
            } else {
                var total = 0;
                var blogPageSize = parseInt($(".bloglanding").data("blogPageSize"), 10);
                var currentlyVisible = $(".experience-component:not(.d-none)").length;
                
                $(".experience-component.d-none").each(function () {
                    total += $(this).find(".blog-column").length;

                    if (currentlyVisible + total <= currentlyVisible + blogPageSize) {
                        $(this).removeClass("d-none");
                        return true;
                    }

                    return false;
                });

                if ($(".experience-component.d-none").length === 0) {
                    $(this).addClass("d-none");
                    $(".blog-post-count").addClass("d-none");
                } else {
                    var count = 0;
                    var $visibleComponents = $(".experience-articleGrid .experience-component").not(".d-none");
    
                    for (var i = 0; i < $visibleComponents.length; i++) {
                        var $visibleComponent = $($visibleComponents[i]);
                        count += $visibleComponent.find(".blog-column").length;
                    }
    
                    $(".blog-post-count__visible").text("Viewing " + count + " of ");
                }
            }
        });

        $(".blog-load-more.blog-load-more--category").on("click", function (e) {
            e.preventDefault();
            $.spinner().start();

            var selectedValueUrl = $(this).attr("data-url");
            var $loadMore = $(this);
            var $loadMoreContainer = $(this).closest(".blogFolder__load-and-count");

            loadMore($loadMore, $loadMoreContainer, selectedValueUrl);
        });
    },
    filterByRoom: function () {
        // All other browsers
        if ($(".blog-room-filter--saved-choice").val()) {
            filterByRoom($(".blog-room-filter--saved-choice").val());
        // Firefox
        } else if (localStorage.room && window.performance) {
            var navEntries = performance.getEntriesByType("navigation");
            var mostRecentEntry = navEntries[0];
            if (mostRecentEntry.type === "back_forward") {
                var roomURL = localStorage.getItem("room");
                filterByRoom(roomURL);
                $(".blog-room-filter option").prop("selected", false);
                $(".blog-room-filter option[value='" + roomURL + "']").prop("selected", "selected");
            }
        }

        $(document).on("change", ".blog-room-filter", function (e) {
            e.preventDefault();

            var selectedValue = $(this).find(":selected").val();
            $(".blog-room-filter--saved-choice").val(selectedValue);
            localStorage.setItem("room", selectedValue);
            filterByRoom(e.currentTarget.value);
        });
    },
    copyArticleLink: function () {
        $("body").on("click", "#copyShareUrlBtnBlog", function () {
            var $btn = $("#copyShareUrlBtnBlog");
            var shareUrl = $btn.data("url");
            navigator.clipboard.writeText(shareUrl);
            $(".copy-link-message").removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        });
    }
};
